import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
import Userauth from "../auth/js/index";

import Body from "../components/body";
import Auth from "../auth/auth";

/* Auth */
import login from "../auth/login";
import Register from "../auth/register";
import resetPassword from '../auth/reset-password.vue'

// import Register from "../pages/authentication/register_image2";

/* maintenance */
import Maintenance from "../pages/maintenance";

/* Error Pages */
import Error400 from "../errors/error_400";
import Error401 from "../errors/error_401";
import Error403 from "../errors/error_403";
import Error404 from "../errors/error_404";
import Error500 from "../errors/error_500";
import Error503 from "../errors/error_503";

/* comingsoon */
import ComingsoonSimple from "../pages/comingsoon/comingsoon_simple";
import ComingsoonImage from "../pages/comingsoon/comingsoon_image";
import ComingsoonVideo from "../pages/comingsoon/comingsoon_video";

/* Authentication */
import LoginOne from "../pages/authentication/login_one";
import LoginTwo from "../pages/authentication/login_two";
import LoginValidate from "../pages/authentication/login_with_validation";
import RegisterImage from "../pages/authentication/register_image";
import RegisterImage2 from "../pages/authentication/register_image2";
import Unlock from "../pages/authentication/unlock";
import ForgetPassword from "../pages/authentication/forget_password";
import ResetPassword from "../pages/authentication/reset_password";

//Notifier
import Dashboard from "../notifier/dashboard/default"
import SendSms from "../notifier/smsManagement/sendSms"
import DynamicSms from "../notifier/smsManagement/dynamicSms"
import SmsTemplate from "../notifier/smsTemplate/smsTemplate"
import PriceAndCoverage from "../notifier/priceAndCoverage/priceAndCoverage"
import ContactGroup from "../notifier/addressBook/contactGroup"
import ManageContact from "../notifier/addressBook/manageContact"
import Billing from "../notifier/billing/billing"
import TodaysReport from "../notifier/deliveryReport/todaysDeliveryReport"
import AllReport from "../notifier/deliveryReport/allTimeDeliveryReport"
import ChangePassword from "../notifier/user/changePassword"
import ApiDocumentation from "../notifier/documentation/apiDocumentation"





// Future Bangladesh

//News
import news from '../pages/future-bangladesh/news/news.vue'
import newsCreate from '../pages/future-bangladesh/news/news_create.vue'
import newsCategory from '../pages/future-bangladesh/news/news_category.vue'
import newsEdit from '../pages/future-bangladesh/news/news_edit.vue'
import customNews from '../pages/future-bangladesh/news/custom_news.vue'


//PLedge Signing
import pledgeSigning from '../pages/future-bangladesh/pledge-signing/pledge-signing.vue'
import submittedContents from '../pages/future-bangladesh/content/contents.vue'
import marathon from '../pages/future-bangladesh/marathon/marathon.vue'
import Announcement from '../pages/future-bangladesh/announcement/announcement.vue'
import AnnouncementCreate from '../pages/future-bangladesh/announcement/announcement_create.vue'
import AnnouncementEdit from '../pages/future-bangladesh/announcement/announcement_edit.vue'


import {store} from "@/store";

Vue.use(Router);

const routes = [
 
    // Admin
    {
        path: "/admin",
        component: Body,
        meta: {
            requiresAuth: true,
        },
        children: [
            //Pledge Signing

             {
                path: "pledge-signing",
                name: "pledgeSigning",
                component: pledgeSigning,
                meta: {
                    title: "Pledge Signing",
                }
            },

            //Submitted Contents
            {
                path: "submitted-contents",
                name: "submittedContents",
                component: submittedContents,
                meta: {
                    title: "Submitted Contents",
                }
            },
            //Marathon
             {
                path: "marathon",
                name: "marathon",
                component: marathon,
                meta: {
                    title: "Marathon",
                }
            },
            
            //Announcement
            {
                path: "announcement",
                name: "announcement",
                component: Announcement,
                meta: {
                    title: "Announcement",
                }
            },
            {
                path: "announcement-create",
                name: "announcementCreate",
                component: AnnouncementCreate,
                meta: {
                    title: "Announcement Create",
                }
            },
            {
                path: "announcement-edit/:slug",
                name: "announcementEdit",
                component: AnnouncementEdit,
                meta: {
                    title: "Announcement Edit",
                }
            },
        
         
            
        ]
    },








    //Notifier
    {
        path: "/auth",
        component: Auth,
        children: [
            {
                path: "login",
                name: "Login 1",
                component: login,
                meta: {
                    title: " login",
                },
            },
           
            
            {
                path: "register",
                name: "register 1",
                component: Register,
                meta: {
                    title: " Register | Ambala",
                }
            },
            {
                path: "reset-password",
                name: "Reset Password",
                component: resetPassword,
                meta: {
                    title: " Reset Password"
                }
            }
        ]
    },

    { path: "", redirect: { name: "slider" } },

    {
        path: "/dashboard",
        component: Body,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "",
                name: "dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            }
        ]
    },



    //Notifier -end


    // {
    //     path: "/dashboard",
    //     component: Body,
    //     meta: {
    //         requiresAuth: true,
    //     },
    //     children: [
    //         {
    //             path: "default",
    //             name: "default",
    //             component: Default,
    //             meta: {
    //                 title: "Default Dashboard | Cuba - Premium Admin Template",
    //             },
    //         },
    //         {
    //             path: "ecommerce",
    //             name: "ecommerce",
    //             component: Ecommerce,
    //             meta: {
    //                 title: "Ecommerce Dashboard | Cuba - Premium Admin Template",
    //             },
    //         },
    //     ],
    // },

    {
        path: "/error-400",
        name: "Error400",
        component: Error400,
        meta: {
            title: "Error400 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-401",
        name: "Error401",
        component: Error401,
        meta: {
            title: "Error401 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-403",
        name: "Error403",
        component: Error403,
        meta: {
            title: "Error403 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-404",
        name: "Error404",
        component: Error404,
        meta: {
            title: "Error404 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-500",
        name: "Error500",
        component: Error500,
        meta: {
            title: "Error500 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/error-503",
        name: "Error503",
        component: Error503,
        meta: {
            title: "Error503 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/maintenance",
        name: "Maintenance",
        component: Maintenance,
        meta: {
            title: "Maintenance | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/comingsoon/comingsoon-simple",
        name: "ComingsoonSimple",
        component: ComingsoonSimple,
        meta: {
            title: "ComingsoonSimple | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/comingsoon/comingsoon-image",
        name: "ComingsoonImage",
        component: ComingsoonImage,
        meta: {
            title: "ComingsoonImage | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/comingsoon/comingsoon-video",
        name: "ComingsoonVideo",
        component: ComingsoonVideo,
        meta: {
            title: "ComingsoonVideo | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/login/one",
        name: "LoginOne",
        component: LoginOne,
        meta: {
            title: "LoginOne | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/login/two",
        name: "LoginTwo",
        component: LoginTwo,
        meta: {
            title: "LoginTwo | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/login/validate",
        name: "LoginValidate",
        component: LoginValidate,
        meta: {
            title: "LoginValidate | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/register/image",
        name: "RegisterImage",
        component: RegisterImage,
        meta: {
            title: "RegisterImage | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/register/image2",
        name: "RegisterImage2",
        component: RegisterImage2,
        meta: {
            title: "RegisterImage2 | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/unlockuser",
        name: "Unlock",
        component: Unlock,
        meta: {
            title: "Unlock | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/forgetpassword",
        name: "ForgetPassword",
        component: ForgetPassword,
        meta: {
            title: "ForgetPassword | Cuba - Premium Admin Template",
        },
    },
    {
        path: "/authentication/resetpassword",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            title: "ResetPassword | Cuba - Premium Admin Template",
        },
    },
];

const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: "history",
    linkActiveClass: "active",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});





router.beforeEach((to, from, next) => {
    console.log("started")
        if (to.meta.title) document.title = to.meta.title;
        let CurrentUser = localStorage.getItem('user')==null? false:true;

        const allowedPaths = [
            "/auth/login",
            "/auth/register",
            "/auth/reset-password",
            "/auth/reset",
           
        ];
        const notAllowedWhenLoggedIn =[
            "/auth/login",
            "/auth/register",
            "/auth/reset-password",
            "/auth/reset",
           
        ];

        const JWTuser = localStorage.getItem("user");

        const matchPath = (path) => {
            return allowedPaths.some(allowedPath => {
                if (allowedPath.includes(":")) {
                    const regexPath = allowedPath.replace(/:\w+/g, "\\w+");
                    const regex = new RegExp(`^${regexPath}$`);
                    return regex.test(path);
                }
                return allowedPath === path;
            });
        };

        if ( matchPath(to.path)){
            console.log("allowed path")
            if(notAllowedWhenLoggedIn.includes(to.path)) {
                if(CurrentUser)
                    return next({
                        path: '/admin/pledge-signing',
                    });
            }
            return next()
        }else{
           store.dispatch('authentication/verify_token',
                localStorage.getItem("access_token")
                ).then(result=>{
                    console.log("after verify", result)

            })
        }

        if( to.path === "/callback" ||
            CurrentUser ||
            Userauth.isAuthenticatedUser() ||
            JWTuser
        ) {
            return next();


        }

        next({
            path: '/auth/login',
            query: { redirect: to.fullPath }
        });

});






export default router;
